// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LYBGBsMb9U0Bl10nHEKs{color:var(--content-negative-primary)}.a_QNBOAK92U4Q1FS2gUc{border:none!important}.DcgaMvCDNJQIYrIim_yz{padding:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `LYBGBsMb9U0Bl10nHEKs`,
	"calendarClassName": `a_QNBOAK92U4Q1FS2gUc`,
	"datePickerWrap": `DcgaMvCDNJQIYrIim_yz`
};
export default ___CSS_LOADER_EXPORT___;
